import React, { useState } from "react";
import { Button, FormFieldSet, useFormHandler } from "../../../../components";
import { BillRateType } from "../../../../assets/data/enumData";

const FillDetailsVendor = ({
  formData,
  errors,
  handleChange,
  isFetchedEntity,
  onboardingId
}) => {
  return (
    <div>
      <div className="m-4">
        {!onboardingId && <div className="grid grid-cols-2 lg:grid-cols-3 gap-4 mb-4">
          <FormFieldSet
            type="allVendorsListOnboarding"
            title="Select Vendor"
            placeholder="Select Vendor"
            value={formData.vendor}
            onChange={(value) => handleChange("vendor", value)}
            error={errors.vendor}
            showSearch
          />
        </div>}

        <div className="grid grid-cols-2 lg:grid-cols-3 gap-4">
          <FormFieldSet
            // type="select"
            title="Business Name"
            placeholder="Enter Business Name"
            value={formData.businessName}
            error={errors.businessName}
            onChange={(value) => handleChange("businessName", value)}
            disabled={true}
            //  options={[
            //   { label: "prudhvi", value: 1 },
            //   { label: "pushpak", value: 2 },
            //   { label: "Sravan", value: 3 },
            //   { label: "sudhakar", value: 4 },
            // ]}
          />
          <FormFieldSet
            title="DBA Business Name"
            placeholder="Enter DBA Business Name"
            value={formData.dbaBusinessName}
            onChange={(value) => handleChange("dbaBusinessName", value)}
            error={errors.dbaBusinessName}
            disabled={true}
          />
          <FormFieldSet
            title="FEIN Number"
            placeholder="Enter FEIN Number "
            value={formData.feinNumber}
            onChange={(value) => handleChange("feinNumber", value)}
            error={errors.feinNumber}
            disabled={true}
          />
          <div className="col-span-2 lg:col-span-3">
            <FormFieldSet
              type="text"
              title="Full Address"
              placeholder="Enter Full Address"
              value={formData.vendorFullAddress}
              onChange={(value) => handleChange("vendorFullAddress", value)}
              error={errors.vendorFullAddress}
              disabled={true}
            />
          </div>
          {/* <FormFieldSet
            type="countriesUsAndCanada"
            title={"Country"}
            placeholder="Select Country"
            value={formData.country}
            onChange={(value) => handleChange("country", value)}
            disabled={isFetchedEntity}
          /> */}
          <FormFieldSet
            type="countriesUsAndCanada"
            title={"Vendor Country"}
            placeholder="Select Country"
            value={formData.vendorCountry}
            onChange={(value) => {
              (handleChange("vendorCountry", value),
                console.log("value", value));
            }}
            disabled={true}
          />

          <FormFieldSet
            showSearch
            type="states"
            title={"State"}
            keyname={"states"}
            placeholder="Select State"
            value={formData?.vendorState}
            error={errors.vendorState}
            onChange={(value) => handleChange("vendorState", value)}
            parentValue={{
              country:
                formData?.vendorCountry?.value ?? formData?.vendorCountry,
            }}
            disabled={true}
          />
          <FormFieldSet
            type="cities"
            showSearch
            keyname={"cities"}
            title={"City"}
            error={errors.vendorCity}
            placeholder="Select City"
            value={formData.vendorCity}
            onChange={(value) => handleChange("vendorCity", value)}
            parentValue={{
              country: formData.vendorCountry?.value ?? formData.vendorCountry,
              state: formData?.vendorState?.value || formData.vendorState,
            }}
            disabled={true}
            // parentId={countryId}
          />
          <FormFieldSet
            type="text"
            title="Zip Code"
            error={errors.vendorZipcode}
            placeholder="Enter Zip Code"
            value={formData.vendorZipcode}
            onChange={(value) => handleChange("vendorZipcode", value)}
            disabled={true}
          />
        </div>
        <div className="mt-5">
          <span className="text-xl">Placement</span>
          <div className="grid grid-cols-2 lg:grid-cols-3 gap-4 mt-4 ">
            <FormFieldSet
              title="Vendor"
              placeholder="Enter Vendor Name"
              error={errors.vendorName}
              value={formData.vendorName}
              onChange={(value) => handleChange("vendorName", value)}
              disabled={true}
            />
            <FormFieldSet
              type="select"
              title="Select Placement Type"
              error={errors.selectPlacementType}
              placeholder="Select Placement"
              value={formData.selectPlacementType}
              onChange={(value) => handleChange("selectPlacementType", value)}
              options={[
                { label: "Contract", value: 1 },
                { label: "Fulltime", value: 2 },
              ]}
            />

            <FormFieldSet
              title="Job Title"
              placeholder="Enter Title"
              error={errors.vendorJobTitle}
              value={formData.vendorJobTitle}
              onChange={(value) => handleChange("vendorJobTitle", value)}
            />
            <div className="grid grid-cols-2 gap-4 ">
              <FormFieldSet
                type="datepicker"
                title="Start Date"
                placeholder="Start Date"
                error={errors.vendorStartDate}
                value={formData.vendorStartDate}
                onChange={(value) => handleChange("vendorStartDate", value)}
                showDropdown={false}
              />
              <FormFieldSet
                type="datepicker"
                title="End Date"
                placeholder="End Date"
                error={errors.vendorEndDate}
                value={formData.vendorEndDate}
                onChange={(value) => handleChange("vendorEndDate", value)}
                showDropdown={false}
              />
            </div>
            <FormFieldSet
              title="Vendor Email"
              placeholder="Enter"
              error={errors.vendorEmail}
              value={formData.vendorEmail}
              onChange={(value) => handleChange("vendorEmail", value)}
            />
            <FormFieldSet
              title="Client"
              placeholder="Enter Client"
              error={errors.vendorClient}
              value={formData.vendorClient}
              onChange={(value) => handleChange("vendorClient", value)}
            />
            <div className="grid grid-cols-2 gap-4 ">
              <FormFieldSet
                title="Bill Rate"
                placeholder="Bill Rate"
                error={errors.billRate}
                value={formData.billRate}
                onChange={(value) => handleChange("billRate", value)}
              />
              <FormFieldSet
                title=""
                type="select"
                placeholder="Hourly"
                error={errors.billRateHourly}
                options={BillRateType}
                value={formData.billRateHourly}
                onChange={(value) => handleChange("billRateHourly", value)}
              />
            </div>
            <FormFieldSet
              type="select"
              title="Tax Terms"
              error={errors.taxTerms}
              placeholder="Enter Tax terms"
              options={[
                { label: "one-term", value: 1 },
                { label: "two-term", value: 2 },
              ]}
              value={formData.taxTerms}
              onChange={(value) => handleChange("taxTerms", value)}
            />
            <FormFieldSet
              title="OT Bill Rate"
              placeholder="OT Bill Rate /hr"
              value={formData.otBillRate}
              error={errors.otBillRate}
              onChange={(value) => handleChange("otBillRate", value)}
            />
            {/* <FormFieldSet
              title="DT Bill Rate"
              placeholder="DT Bill Rate /hr"
              value={formData.dtBillRate}
              onChange={(value) => handleChange("dtBillRate", value)}
            /> */}
            {/* <div className="grid grid-cols-2 gap-4 ">
              <FormFieldSet
                title="Pay Rate"
                placeholder="Pay Rate /hr"
                value={formData.payRate}
                onChange={(value) => handleChange("payRate", value)}
              />
              <FormFieldSet
                title=""
                placeholder="Hourly"
                // options={[
                //   { label: "12/hr", value: 1 },
                //   { label: "24/hr", value: 2 },
                // ]}
                value={formData.payRateHourly}
                onChange={(value) => handleChange("payRateHourly", value)}
              />
            </div>
            <FormFieldSet
              title="OT Pay Rate"
              placeholder="OT Pay Rate /hr"
              value={formData.otPayRate}
              onChange={(value) => handleChange("otPayRate", value)}
            /> */}
          </div>
        </div>
        <div className="mt-5">
          <span className="text-xl">Contacts</span>
          <div className="grid grid-cols-2 lg:grid-cols-3 gap-4 mt-4 ">
            {/* <FormFieldSet
              title="Primary Contact"
              placeholder="Enter Contact Name"
              value={formData.primaryContact}
              onChange={(value) => handleChange("primaryContact", value)}
            /> */}
            <FormFieldSet
              title="Primary Contact Name"
              placeholder="Enter Contact Name"
              value={formData.primaryContactNumber}
              onChange={(value) => handleChange("primaryContactNumber", value)}
              error={errors.primaryContactNumber}
              disabled={true}
            />

            <FormFieldSet
              title="Job Title"
              placeholder="Enter Job Title"
              value={formData.vendorTitle}
              onChange={(value) => handleChange("vendorTitle", value)}
              error={errors.vendorTitle}
              disabled={true}
            />
            <FormFieldSet
              title="Email"
              placeholder="Enter Email"
              value={formData.vendorContactEmail}
              onChange={(value) => handleChange("vendorContactEmail", value)}
              error={errors.vendorContactEmail}
              disabled={true}
            />
            <FormFieldSet
              title="Phone Number"
              placeholder="Enter Phone Number"
              value={formData.vendorContact}
              onChange={(value) => handleChange("vendorContact", value)}
              error={errors.vendorContact}
              disabled={true}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FillDetailsVendor;
